module.exports = __webpack_public_path__ + "static/media/running.341e1399.mp4";